import React, { useState, useEffect } from 'react'
import { RadioButton, ContextualAlert, CaptionText } from '@paypalcorp/pp-react'
import { trackClick, trackFormValidationClick } from 'ppbl/utils/fpti-helper'

const RadioButtonAdapter = ({ input, meta, fptiPage, ...rest }) => {
  const [radioState, setRadioState] = useState(input.value)

  delete input.checked

  const handleChange = (e) => {
    const target = e.target
    setRadioState(target.value)
    input.onChange(target.value)
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackFormValidationClick({
        page: fptiPage,
        message: meta.error,
        component: input.name,
        link: input.name,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <>
      <RadioButton
        {...input}
        {...rest}
        value={radioState}
        onChange={handleChange}
      />
      {meta.touched && meta.error && (
        <ContextualAlert type="error" style={{ padding: 0 }}>
          <CaptionText>{meta.error}</CaptionText>
        </ContextualAlert>
      )}
    </>
  )
}

export default RadioButtonAdapter
